// What the URL was asking for when the app started.
//
// Read once, at module load, because the readers downstream destroy the
// evidence: session.js strips the auth fragment before React mounts, and
// ClaimGate removes ?claim once it has it. Anything deciding whether to show
// the login wall has to know what the URL said *originally*.

const RETURN_KEY = 'ihsanone_return_to';

function readOnce() {
  if (typeof window === 'undefined') {
    return { continueLink: false, claim: false, recover: false, search: '' };
  }
  const search = window.location.search || '';
  const hash = window.location.hash || '';
  const params = new URLSearchParams(search);
  return {
    // Verify-on-click magic link: ?continue=1#th=<token_hash>
    continueLink: params.get('continue') === '1' || /(^|[#&])th=/.test(hash),
    // Pass claim: ?claim=<token>, or #claim=<token> as a fallback
    claim: Boolean(params.get('claim')) || /(^|[#&])claim=/.test(hash),
    // Password reset: ?recover=1#th=<token_hash>&em=<email>. RecoverGate
    // handles the exchange + new-password form; the login wall must let it
    // through the same way it does for magic-link and pass-claim.
    recover: params.get('recover') === '1',
    search,
  };
}

const intent = readOnce();

export const hasContinueIntent = intent.continueLink;
export const hasClaimIntent = intent.claim;
export const hasRecoverIntent = intent.recover;

/**
 * True when this load is part of an email funnel. The login wall must never
 * cover these: ContinueGate, ClaimGate and RecoverGate are how a member signs
 * in / resets their password from a link, so hiding them behind a sign-up
 * form would break the AAC door.
 */
export const hasDeepLinkIntent = intent.continueLink || intent.claim || intent.recover;

/**
 * Remember where the member was heading, so a shared listing link still lands
 * somewhere useful after they sign in. The #th token is never stored — it is a
 * single-use credential and belongs only in the fragment.
 */
export function stashReturnTo() {
  if (typeof window === 'undefined') return;
  if (!intent.search || intent.claim || intent.continueLink) return;
  try {
    window.sessionStorage.setItem(RETURN_KEY, intent.search);
  } catch {
    /* private mode — the member just lands on Home */
  }
}

export function takeReturnTo() {
  try {
    const value = window.sessionStorage.getItem(RETURN_KEY);
    window.sessionStorage.removeItem(RETURN_KEY);
    return value || null;
  } catch {
    return null;
  }
}
